import styled from "styled-components";

import {
  AiOutlineUser,
  IoIosNotifications,
  AiOutlineAreaChart,
} from "react-icons/all";

export const ProfileTitle = styled.h3`
  color: ${(p) => p.theme.profileSettingColor};

  margin-left: 7rem;

  @media (max-width: 991px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (min-width: 1660px) {
    margin-left: 9.6rem;
  }
`;

export const ProfileIcon = styled(AiOutlineUser)`
  margin-right: 0.8rem;
  margin-bottom: 0.3rem;
  font-size: 1.2rem;
`;

export const NotificationIcon = styled(IoIosNotifications)`
  margin-right: 0.8rem;
  margin-bottom: 0.3rem;
  font-size: 1.2rem;
`;

export const EarningIcon = styled(AiOutlineAreaChart)`
  margin-right: 0.8rem;
  margin-bottom: 0.3rem;
  font-size: 1.2rem;
`;

export const ProfileWrapper = styled.div`
  .connectWallet {
    margin-left: -11rem;
    margin-top: 3rem;
  }
`;
